export default __webpack_public_path__ + "static/media/github.6e80c38a.svg";